import { FEATURE_QUERY_PARAM } from './feature.constants'
import type { FeatureEnv } from './feature.types'

/**
 * Reads the feature value exclusively from the current browser URL.
 * Returns null on the server or when the param is absent.
 *
 * This helper has a single responsibility: read the URL.
 * For URL-then-sessionStorage resolution use `resolveClientFeature`.
 */
export function getFeatureFromSearchParams(): FeatureEnv {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(FEATURE_QUERY_PARAM)
}
